/**
 * @generated SignedSource<<759827f1c4172a6f4074d40da2b8d138>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type salesChannelProductsOnDefaultQuery$variables = Record<PropertyKey, never>;
export type salesChannelProductsOnDefaultQuery$data = {
  readonly productsOnDefaultSalesChannel: ReadonlyArray<{
    readonly name: string;
    readonly productID: number;
  }>;
};
export type salesChannelProductsOnDefaultQuery = {
  response: salesChannelProductsOnDefaultQuery$data;
  variables: salesChannelProductsOnDefaultQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProductBySalesChannel",
    "kind": "LinkedField",
    "name": "productsOnDefaultSalesChannel",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelProductsOnDefaultQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "salesChannelProductsOnDefaultQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "0864d84c736130c67a22e052a3b7cf4b",
    "id": null,
    "metadata": {},
    "name": "salesChannelProductsOnDefaultQuery",
    "operationKind": "query",
    "text": "query salesChannelProductsOnDefaultQuery {\n  productsOnDefaultSalesChannel {\n    productID\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "58608ec219948f8d78e7bc48662f6b8e";

export default node;
